
import React, {Component} from 'react'
import CdnImage from '../../components/cdnImage/cdnImage.js'
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsPlusLg } from "react-icons/bs";

const configurationManager = require('../../utils/config/configurationManager.js');
const themeUtil = require('../../utils/view/themeUtil.js');
const navigationButtonsIds = require('../Navigation/navigationButtonsIds.js');
const translator = require('../../utils/translator/translator.js');

class PageButton extends Component 
{

    render()
    {
        if (this.props.button == navigationButtonsIds.blank)
        {
            return this.renderBlankButton();
        }
        else
        {
            return this.renderStandardButton();
        }

    }

    renderStandardButton()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        var size = Math.round(window.innerWidth*0.05);

        return <div style={{marginLeft:this.props.marginLeft, marginRight:this.props.marginRight}}>
                    <div style={{width:window.innerWidth*0.12, height: window.innerWidth*0.12, border:`1px solid var(--colors-primary)`, borderRadius:'10px'}}>
                        <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center'}}>
                            <div style={{animation: "spin 3s linear infinite"}}>
                                <CdnImage cloudName={cloudName} width={size} publicId={themeUtil.getPublicId(`${this.props.button}.png`)}/>
                            </div>
                            <div className="caption primary-color" style={{animation: "spin 3s linear infinite", marginTop:'5px', paddingLeft:'10px', paddingRight:'10px'}}>
                                {translator.getLabel(this.props.button)}
                            </div>

                            <div style={{position:'fixed', top:'-40%', left:3, fontSize:'2.0rem', color:'#BEBEBE'}} onClick={this.props.onDelete}>
                                <AiOutlineCloseCircle/>
                            </div>   
                            
                        </div>
                    </div>
                </div>
    }

    renderBlankButton()
    {
        let onClick = ()=>{this.props.onClick(this.props.button)};

        return <div onClick={this.props.onAdd} style={{marginLeft:this.props.marginLeft, marginRight:this.props.marginRight}}>
                    <div style={{width:window.innerWidth*0.12, height: window.innerWidth*0.12, border:`1px solid var(--colors-primary)`, borderRadius:'10px'}}>
                        <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center', fontSize:'4rem', color:'#C0C0C0'}}>
                            <BsPlusLg/>
                        </div>
                    </div>
                </div>
    }

}

export default PageButton